import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    IDatiqTimelineInput,
    IDatiqTimelineInputTab,
    emptyDatiqTimelineInput,
} from './models';
import { AbstractControl, FormGroup } from '@angular/forms';
import {
    DatiqInputService,
    IDatiqOption,
} from '@dat/datiq-components-pkg/utils';
import { DatiqTimelineInputService } from './services';
import {
    DatiqSelectTypesInput,
    DatiqSelectTypesSelect,
} from '@dat/datiq-components-pkg/select';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'datiq-timeline-input',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './datiq-timeline-input.component.html',
    styleUrls: ['./datiq-timeline-input.component.scss'],
})
export class DatiqTimelineInputComponent implements OnInit {
    @Input()
    settings: IDatiqTimelineInput;

    @Input()
    formGroup: FormGroup;

    @Input()
    inputControl: AbstractControl;

    @Output()
    tabClicked: EventEmitter<IDatiqTimelineInputTab> =
        new EventEmitter<IDatiqTimelineInputTab>();

    selectControl: AbstractControl;
    selectControl$: Observable<DatiqSelectTypesSelect>;
    inputControl$: Observable<DatiqSelectTypesInput>;
    formGroup$: Observable<{ [key: string]: DatiqSelectTypesInput }>;
    selectedValue: string;

    constructor(
        private _inputService: DatiqInputService,
        private _service: DatiqTimelineInputService
    ) {}

    ngOnInit(): void {
        this.settings = !!this.settings
            ? this.settings
            : { ...emptyDatiqTimelineInput };

        this.formGroup = !!this.formGroup
            ? this.formGroup
            : this._inputService.createForm();

        this.inputControl = !!this.inputControl
            ? this.inputControl
            : this._inputService.createControl(this.settings, this.formGroup);

        this.selectedValue = this.inputControl.value.value;

        this.inputControl$ = this.inputControl.valueChanges.pipe(
            tap((inputValue: IDatiqTimelineInputTab) => {
                this.selectedValue = inputValue.value;
            })
        );
    }

    tabClick(tab: IDatiqTimelineInputTab): void {
        this.tabClicked.emit(tab);
        this.inputControl.setValue(tab);
    }
}

// Path: libs/datiq-components/datiq-timeline/src/lib/components/datiq-timeline-input/datiq-timeline-input.component.ts
